import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Copyright from "../components/Copyright";
import ChartUserByCountry from "./ChartUserByCountry";
import CustomizedTreeView from "./CustomizedTreeView";
import CustomizedDataGrid from "./CustomizedDataGrid";
import HighlightedCard from "./HighlightedCard";
import PageViewsBarChart from "./PageViewsBarChart";
import SessionsChart from "./SessionsChart";
import StatCard from "./StatCard";
import PROJECT_SERVICE from "../../api/project";
import { useEffect, useState } from "react";


export default function MainGrid() {

  const [projectCount, setProjectCount] = useState([]);

  async function getDashboardProjectCount() {
    const res = await PROJECT_SERVICE.all();
    if (res.status === 200) {
      setProjectCount(res?.data);
    }
  }

  useEffect(() => {
    getDashboardProjectCount();
  }, []);


  const data = [
    {
      title: "Projects",
      value: projectCount && projectCount?.length || 0,
      interval: "",
    },
  ]

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      {/* cards */}

      {/*<p>sdasd</p>*/}
      <Typography
        component="h2"
        variant="h6"
        sx={{ mb: 2 }}
      >
        Overview
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: theme => theme.spacing(2) }}
      >
        {data?.map((card, index) => (
          <Grid
            key={index}
            size={{ xs: 12, sm: 6, lg: 3 }}
          >
            <StatCard {...card} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
